<template>
    <nav class="navbar navbar-default">
        <div class="container-fluid">
            <div class="navbar-header">
                <router-link class="navbar-brand" to="/calendar">
                    Manager {{companyName}}
                </router-link>
            </div>
            <div class="pull-right">
                <p class="navbar-text hidden-xs hidden-sm">
                    Ciao, {{adminClientFirstName}} ({{companyName}})
                </p>
                <i class="las la-bars visible-xs visible-sm" data-toggle="collapse" data-target="#left-menu" aria-expanded="false"></i>


            </div>
        </div>
    </nav>
</template>

<script>
    import {StorageHelper} from "../../common/storageHelper";

    export default {
        name: "Header",
        data : function () {
            return {
                companyName: "",
                adminClientFirstName: "",
                adminClientName: "",
                adminClientEmail: "",
            }
        },
        mounted() {
            const user = StorageHelper.getUser();
            this.companyName = user.company.display_name;
            this.adminClientFirstName = user.first_name;
            this.adminClientName = user.first_name + " " + user.last_name;
            this.adminClientEmail = user.email;
        }
    };
</script>
